module.exports = __webpack_public_path__ + "Gilles_Pons_Web_Over.jpg?b6442b50b6e4bf483f4d4d5ca2311aea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Gilles_Pons_Web_Over.jpg
// module id = 178
// module chunks = 0